// extracted by mini-css-extract-plugin
export default {"pgrid":"AddressForm_pgrid__eTjFv","span2":"AddressForm_span2__HQYrX"};